import type { AppError } from "../../models/AppError";

export interface ErrorDisplayProps {
  error?: AppError;
  onClose: () => void;
}

export function ErrorDisplay(props: ErrorDisplayProps) {
  const title = props.error?.title ?? "Something went wrong";
  const validationErrors = props.error?.validationErrors
    ? Object.entries(props.error.validationErrors).flatMap(
        ([property, messages]) =>
          messages.map((message) => ({ property, message })),
      )
    : [];

  return {
    isOpen: Boolean(props.error),
    title,
    message: props.error?.message,
    validationErrors,
    onClose: props.onClose,
  };
}
